(() => {
  'use strict';

  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  const inited = new WeakSet();

  const loadStylesheet = (href) => {
    if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = reject;
      document.head.appendChild(link);
    });
  };

  const loadScript = (src) => {
    if (window.Swiper) return Promise.resolve();
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      return new Promise((resolve) => {
        if (window.Swiper) {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
      });
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  const setupReadMore = (root) => {
    root.querySelectorAll('[data-gr-review-text]').forEach((textEl) => {
      const card = textEl.closest('[data-gr-card]');
      const toggle = card?.querySelector('[data-gr-read-more]');
      if (!toggle) return;

      const openText = toggle.getAttribute('data-open-text') || 'Lees verder';
      const collapseText = toggle.getAttribute('data-collapse-text') || 'Verbergen';
      const label = toggle.querySelector('[data-gr-read-more-label]');

      const updateVisibility = () => {
        if (textEl.classList.contains('is-expanded')) {
          toggle.hidden = false;
          return;
        }
        const overflows = textEl.scrollHeight > textEl.clientHeight + 2;
        toggle.hidden = !overflows;
        if (label) label.textContent = openText;
      };

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const expanded = textEl.classList.toggle('is-expanded');
        if (label) label.textContent = expanded ? collapseText : openText;
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      updateVisibility();
      window.addEventListener('resize', updateVisibility);
    });
  };

  const initRoot = (root) => {
    if (!root || inited.has(root) || !window.Swiper) return;
    const swiperEl = root.querySelector('[data-gr-swiper]');
    if (!swiperEl) return;

    inited.add(root);

    const spaceBetween = Number(root.dataset.spaceBetween || 20);
    const autoplayDelay = Number(root.dataset.autoplay || 0);
    const loop = root.dataset.loop === 'true';

    const config = {
      slidesPerView: 1,
      spaceBetween,
      loop,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: root.querySelector('[data-gr-next]'),
        prevEl: root.querySelector('[data-gr-prev]')
      },
      breakpoints: {
        750: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 3
        }
      }
    };

    if (autoplayDelay > 0) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    // eslint-disable-next-line no-new
    new window.Swiper(swiperEl, config);
    setupReadMore(root);
  };

  const initAll = async () => {
    const roots = document.querySelectorAll('[data-google-reviews]');
    if (!roots.length) return;

    try {
      await loadStylesheet(SWIPER_CSS);
      await loadScript(SWIPER_JS);
      roots.forEach((root) => initRoot(root));
    } catch (error) {
      console.error('Google reviews slider failed to load Swiper', error);
    }
  };

  window.GoogleReviewsInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('[data-google-reviews]')) {
      initAll();
    }
  });
})();
